export default __webpack_public_path__ + "static/media/detailed.a2677837.jpg";